import styled from 'styled-components';

export const RadioButtonGroupWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 16px;
  row-gap: 12px;
`;
